export const DOWNLOAD_ERROR = 'Не вдалося завантажити дані команди. Будь ласка, спробуйте пізніше.';
export const VIDEO_TEXT_STRING1 = 'Я тут, тому що знаю з власного досвіду – коні нас рятують.';
export const VIDEO_TEXT_STRING2 = 'Очі учасників після програми – найкраща мотивація.';
export const VIDEO_TEXT_STRING3 = 'І можливість привідкрити глибину цього світу людям,';
export const VIDEO_TEXT_STRING4 = 'які до нього не були дотичні, а потім спостерігати цей';
export const VIDEO_TEXT_STRING5 = 'особливий ефект, вартує дорогого.';
export const VIDEO_TEXT_AUTHOR = 'Вікторія Яковенко';
